/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, PLATFORM_ID, computed, inject } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { SearchResponse } from '@core/models/domains/hotel';
import { SearchResultUiService } from '../services/search-result-ui.service';
import { UtmService } from '@core/services/utm.service';
import { AuthService } from '@core/services/authentication/auth.service';
import { SearchBoxService } from '@shared/services/serach-box.service';

export const searchResultResolver: ResolveFn<void> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  searchResultUiService: SearchResultUiService = inject(SearchResultUiService),
  authService: AuthService = inject(AuthService),
  router: Router = inject(Router),
  platformId: Object = inject(PLATFORM_ID),
  utmService: UtmService = inject(UtmService),
  searchBoxService: SearchBoxService = inject(SearchBoxService)
) => {

  if (
    [undefined, null, '', 'null', 'a'].includes(route.params?.['city-name']) &&
    !route.params['pageGenerator'] &&
    !route.params['typeName'] &&
    !route.params['country']) {
    return;
  }
  let isSearch = computed(() => searchBoxService.isSearch());
  const queryParams = route.queryParams;

  const params = route.params;


  if (params?.['typeName']) {
    if (
      searchResultUiService.ecolodgeTypeName() !== params['typeName'] &&
      searchResultUiService.ecolodgeTypeName()
    ) {
      searchResultUiService.fetchedPages = [];
      searchResultUiService.pageIndex = 0;
      searchResultUiService.searchResult.set({} as SearchResponse);
      searchResultUiService.hotelsList.set([]);
      searchResultUiService.prevPageLoading.set(true);
    }
    searchResultUiService.ecolodgeTypeName.set(params['typeName']);
  }

  if (queryParams?.['hostId']) {
    if (
      searchResultUiService.ecolodgeHostId() !== queryParams?.['hostId'] &&
      searchResultUiService.ecolodgeHostId()
    ) {
      searchResultUiService.fetchedPages = [];
      searchResultUiService.pageIndex = 0;
      searchResultUiService.searchResult.set({} as SearchResponse);
      searchResultUiService.hotelsList.set([]);
      searchResultUiService.prevPageLoading.set(true);
    }
    searchResultUiService.ecolodgeHostId.set(queryParams?.['hostId']);
  }

  const searchBoxQuery = queryParams?.['search_box']
    ? isPlatformServer(platformId)
      ? encodeURIComponent(queryParams['search_box'])
      : queryParams['search_box']
    : null;

  const findCountry = !state.url.includes('ecolodge') && params['country'] ? 1 : -1;
  const splittedCityName = findCountry == -1 && params['city-name'] ?
   params['city-name']?.split('-') : '';
  let CityName = '';
  let countryName = (findCountry  > -1 && !params['country'] && !state.url.includes('ecolodge') && !state.url.includes('map')) ?
    params['city-name'] : params['country'] ? encodeURIComponent(params['country']) : '';
  searchResultUiService.isCountryPage.set(countryName ? true : false)
  CityName = (!state.url.includes('ecolodge') && params['city-name'] && params['country']) ?
    encodeURIComponent(params['city-name']) :
    state.url.includes('map') && params['city-name'] ? encodeURIComponent(params['city-name']) :
      '';
  if (state.url.includes('ecolodge')) {
    CityName = isPlatformServer(platformId)
      ? encodeURIComponent(params['city-name'])
      : params['city-name'];
  } else if (findCountry == -1 && params['city-name'].search(/-hotels/)  > -1) {
    //we have a param like : mashad-hotels or torbat-e-heydarie-hotels ==> and we want to remove the hotels word from its end
    splittedCityName.pop();
    CityName = isPlatformServer(platformId)
      ? encodeURIComponent(splittedCityName.join('-'))
      : splittedCityName.join('-');
  }


  if (
    (Object.keys(searchResultUiService.lastUsedPayload ?? {}).length &&
      !Object.keys(queryParams).length) ||
    CityName !== searchResultUiService.lastUsedPayload.CityName ||
    (searchBoxQuery &&
      queryParams['search_box'] !== searchResultUiService.lastUsedPayload?.SearchQuery) ||
    (queryParams?.['date'] &&
      queryParams['date'] !== searchResultUiService.lastUsedPayload?.StartDate) ||
    (queryParams?.['endDate'] &&
      queryParams['endDate'] !== searchResultUiService.lastUsedPayload?.EndDate)
  ) {

    if (!params?.['typeName'] && !queryParams?.['hostId'] && !queryParams['page'] && isSearch()) {
      // برای حالتی که کاربر از طریق سرچ باکس خود صفحه نویگیشن انجام دهد
      searchResultUiService.fetchedPages = [];
      searchResultUiService.pageIndex = 0;
      searchResultUiService.searchResult.set({} as SearchResponse);
      searchResultUiService.hotelsList.set([]);
      searchResultUiService.prevPageLoading.set(true);
    }
  }
 
 
 utmService.checkRouteParams(route.queryParamMap);
  const isEcolodge = state.url.includes('/ecolodge') || params?.['typeName'];
  const accommodation = isEcolodge ? 'ecolodge' : 'hotel';
  if (countryName && !state.url.includes('ecolodge')){
  return searchResultUiService.getHotels(
    {
      ...queryParams,
      search_box: !params?.['typeName'] ? searchBoxQuery : '',
      CityName:CityName,
      CountryName: countryName,
      types: state.url.includes('ecolodge') ? 3 : queryParams['types'] ?? '',
      refer: !queryParams?.['date'] || !queryParams?.['endDate'] ? 'iranlist' : queryParams['refer'],
      typeName:
        params?.['typeName'] && route.data['accommodation'] == 'ecolodge'
          ? params['typeName']
          : undefined,
    },
    route.params['pageGenerator'] ?? undefined,
    accommodation
  );
}else{
  return searchResultUiService.getHotels(
    {
      ...queryParams,
      search_box: !params?.['typeName'] ? searchBoxQuery : '',
      CityName:
        CityName == 'ecolodge' ? queryParams['search_box'] : params?.['typeName'] ? '' : CityName,
      types: state.url.includes('ecolodge') ? 3 : queryParams['types'] ?? '',
      refer: !queryParams?.['date'] || !queryParams?.['endDate'] ? 'iranlist' : queryParams['refer'],
      typeName:
        params?.['typeName'] && route.data['accommodation'] == 'ecolodge'
          ? params['typeName']
          : undefined,
    },
    route.params['pageGenerator'] ?? undefined,
    accommodation
  );
}

};
